/**
 * The "Official Partner" pill — a formal GOMPA↔monastery partnership, staff-set
 * (Admin → monastery → Verify). Click it for a one-paragraph explainer, the
 * same pattern as the "GOMPA Verified" badge. Used on the monastery page and
 * on the Explore / landing cards, so the copy lives in one place.
 */
import { useTranslation } from 'react-i18next';
import InfoBadge from './InfoBadge';

export default function PartnerBadge() {
  const { t } = useTranslation();
  return (
    <InfoBadge
      tone="partner"
      className="tag tag--partner"
      label={t('monasteryDetail.officialPartner', 'Official Partner')}
      title={t('monasteryDetail.officialPartnerTitle', 'What does Official Partner mean?')}
      body={t(
        'monasteryDetail.officialPartnerBody',
        'GOMPA and this monastery have a formal partnership. GOMPA works directly with its administration on its listing, its offerings, and how contributions reach it.'
      )}
    />
  );
}
